import once from '@lib/once';
function initProductTeaserListFilters(filter) {
    const grid = filter.parentElement.querySelector('.product-teaser-card-list--with-filters');
    const iso = new Isotope(grid, {
        itemSelector: '.grid__column',
        layoutMode: 'fitRows',
        fitRows: {
            equalheight: true,
        },
    });

    filter.querySelectorAll('button').forEach((button) => {
        button.addEventListener('click', (e) => {
            if (e.target.classList.contains('active')) {
                e.target.classList.remove('active');
            } else {
                e.target.classList.add('active');
            }
            const selectors = [];
            e.target.parentElement.querySelectorAll('.active').forEach((el) => selectors.push(el.dataset.filter));
            iso.arrange({ filter: selectors.join(',') });
        });
    });
}

window.Drupal.behaviors.productTeaserListFilters = {
    attach: (context) => {
        const filters = context.querySelectorAll('.product-teaser-cards-filters');
        for (const filter of filters) {
            once('productTeaserListFilters', initProductTeaserListFilters, [filter]);
        }
    },
};
